export enum ElementTypes {
  FILE = 'FILE',
  ALBUM = 'ALBUM',
}

export enum FileTypes {
  IMG = 'photo',
  VIDEO = 'video',
}
